import client from '../../../../common/client';
import aws from 'aws-sdk';
import uuid from 'uuid';

export const ADD_SWING_TO_SUBMITTAL = 'ADD_SWING_TO_SUBMITTAL';
export const GET_SWING_SUBMITTALS = 'GET_SWING_SUBMITTALS';
export const GET_SWING_SUBMITTAL_TYPES = 'GET_SWING_SUBMITTAL_TYPES';
export const PURCHASE_SWING_SUBMITTALS = 'PURCHASE_SWING_SUBMITTALS';
export const UPLOADING_SWING_SUBMITTAL_PROGRESS = 'UPLOADING_SWING_SUBMITTAL_PROGRESS';
export const UPLOADING_SWING_SUBMITTAL_COMPLETE = 'UPLOADING_SWING_SUBMITTAL_COMPLETE';

export const getSwingSubmittals = () => ({
  promise: client.get('swing-submittals', null, {
    credentials: 'include', // Required for browser to respect Set-Cookie headers
  }),
  type: GET_SWING_SUBMITTALS,
});

export const getSwingSubmittalTypes = () => ({
  promise: client.get('swing-submittals/types'),
  type: GET_SWING_SUBMITTAL_TYPES,
});

export const purchaseSwingSubmittal = payload => ({
  promise: client.post(`swing-submittals`, payload),
  type: PURCHASE_SWING_SUBMITTALS,
});

export const addSwingToSubmittal = (submittalId, key, location) => ({
  promise: client.post(`swing-submittals/${submittalId}/swing`, { key, location }),
  type: ADD_SWING_TO_SUBMITTAL,
  submittalId,
});

export function updateUploadProgress(swingSubmittalId, loaded, total) {
  return {
    type: UPLOADING_SWING_SUBMITTAL_PROGRESS,
    swingSubmittalId,
    loaded,
    total,
  };
}

const uploadVideoToS3 = (dispatch, swingSubmittalId, file) => {
  const params = {
    Key: `${uuid.v4()}`,
    Body: file,
    ContentType: file.type,
  };

  return client
    .get(`swing-submittals/upload-token?submittalId=${swingSubmittalId}`)
    .then(response =>
      response.json().then(json => {
        params.Bucket = json.Bucket;
        aws.config.correctClockSkew = true;
        aws.config.update({ region: json.Region });
        aws.config.apiVersions = {
          s3: '2006-03-01',
          // other service API versions
        };
        aws.config.credentials = new aws.CognitoIdentityCredentials({
          IdentityPoolId: json.IdentityPoolId,
          IdentityId: json.IdentityId,
          Logins: {
            'cognito-identity.amazonaws.com': json.Token,
          },
        });

        return new aws.S3();
      })
    )
    .then(s3Client =>
      s3Client
        .upload(params)
        .on('httpUploadProgress', evt => {
          dispatch(updateUploadProgress(swingSubmittalId, evt.loaded, evt.total));
        })
        .promise()
    );
};

export function uploadVideo(swingSubmittalId, file) {
  return dispatch => {
    return uploadVideoToS3(dispatch, swingSubmittalId, file, updateUploadProgress)
      .then(data => {
        dispatch(addSwingToSubmittal(swingSubmittalId, data.Key, data.Location));
      })
      .then(() => {
        dispatch({
          type: UPLOADING_SWING_SUBMITTAL_COMPLETE,
          swingSubmittalId,
        });
      });
  };
}



// WEBPACK FOOTER //
// ./src/subscription/coaching/swing-submittals/redux/actions.js